import {
  FETCH_KEYWORD_RESEARCH_IN_PROGRESS,
  FETCH_KEYWORD_RESEARCH_SUCCESSFUL,
  FETCH_KEYWORD_RESEARCH_FAILED,
  CHANGE_SELECTED_RESEARCH_TYPE
} from "./types";

import { LOGOUT } from "../iam/types";

const initialState = {
  network_activity: [],
  research_types: [
    { title: "Broad Match keywords", key: "phrase_fullsearch" },
    { title: "Related Keywords", key: "phrase_related" },
    { title: "Phrase Questions", key: "phrase_questions" }
  ],
  selected_research_type: "phrase_fullsearch",
  default_seo_db: "us",
  title: "Keyword research",
  data: {}
};

const networkActivityMessages = {
  fetchKeywordResearch: "fetch_keyword_research_"
};

const keywordResearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_KEYWORD_RESEARCH_IN_PROGRESS: {
      const loadingKey = `${action.keyword}:${action.researchType}:${action.seoDb}`;
      return {
        ...state,
        network_activity: [...state.network_activity, `${networkActivityMessages["fetchKeywordResearch"]}${loadingKey}`]
      };
    }
    case FETCH_KEYWORD_RESEARCH_SUCCESSFUL: {
      const loadingKey = `${action.keyword}:${action.researchType}:${action.seoDb}`;
      const hKey = `${action.researchType}:${action.seoDb}`;
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${networkActivityMessages["fetchKeywordResearch"]}${loadingKey}`
        ),
        selected_research_type: action.researchType,
        data: {
          ...state.data,
          [action.keyword]: {
            ...state.data[action.keyword],
            [hKey]:
              state.data[action.keyword] &&
              state.data[action.keyword][hKey] &&
              state.data[action.keyword][hKey]["keywords"]
                ? {
                    ...state.data[action.keyword][hKey],
                    keywords: [...state.data[action.keyword][hKey]["keywords"], ...action.result["keywords"]],
                    has_more: action.result["has_more"]
                  }
                : {
                    keywords: action.result["keywords"],
                    has_more: action.result["has_more"]
                  }
          }
        }
      };
    }
    case FETCH_KEYWORD_RESEARCH_FAILED: {
      const loadingKey = `${action.keyword}:${action.researchType}:${action.seoDb}`;
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${networkActivityMessages["fetchKeywordResearch"]}${loadingKey}`
        )
      };
    }
    case CHANGE_SELECTED_RESEARCH_TYPE:
      return {
        ...state,
        selected_research_type: action.researchType
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};

export default keywordResearchReducer;
